var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmileyRatingExcellent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 863.8 774.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #3cae76;\r\n      }\r\n      .cls-2 {\r\n        fill: #FFFFFF;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 431.9,
    cy: 387.34,
    r: 332.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m426.46,774.69c-213.58,0-387.34-173.77-387.34-387.34S212.88,0,426.46,0s387.34,173.77,387.34,387.34-173.77,387.34-387.34,387.34Zm0-720.32c-183.61,0-332.98,149.37-332.98,332.98s149.37,332.98,332.98,332.98,332.98-149.37,332.98-332.98S610.07,54.36,426.46,54.36Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 307.31,
    cy: 284.73,
    r: 61.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 545.6,
    cy: 284.73,
    r: 61.28
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m307.43,452c-18.06,0-31.08,17.01-26.92,34.59,15.62,66.14,75.03,115.36,145.95,115.36s130.33-49.22,145.95-115.36c4.15-17.58-8.86-34.59-26.92-34.59h-238.04Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyRatingExcellent);
export default __webpack_public_path__ + "static/media/smiley-rating-excellent.558424db1a7344c052ec2be3165d4049.svg";
export { ForwardRef as ReactComponent };